export default __webpack_public_path__ + "src/images/packages/ngama-tented-lodge/f5d800624be155f9c3c690ce5e49865d-5.jpg";